import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import { z } from "zod"

import {
  DEFAULT_LOCALE,
  readLocale,
  writeLocale,
  type Locale,
} from "@/lib/storage/locale-storage"

import enAuth from "./locales/en/auth.json"
import enCommon from "./locales/en/common.json"
import enContracts from "./locales/en/contracts.json"
import enCooperatives from "./locales/en/cooperatives.json"
import enDashboard from "./locales/en/dashboard.json"
import enDocuments from "./locales/en/documents.json"
import enIntake from "./locales/en/intake.json"
import enLots from "./locales/en/lots.json"
import enMilling from "./locales/en/milling.json"
import enNav from "./locales/en/nav.json"
import enOrders from "./locales/en/orders.json"
import enTransit from "./locales/en/transit.json"
import enValidation from "./locales/en/validation.json"
import frAuth from "./locales/fr/auth.json"
import frCommon from "./locales/fr/common.json"
import frContracts from "./locales/fr/contracts.json"
import frCooperatives from "./locales/fr/cooperatives.json"
import frDashboard from "./locales/fr/dashboard.json"
import frDocuments from "./locales/fr/documents.json"
import frIntake from "./locales/fr/intake.json"
import frLots from "./locales/fr/lots.json"
import frMilling from "./locales/fr/milling.json"
import frNav from "./locales/fr/nav.json"
import frOrders from "./locales/fr/orders.json"
import frTransit from "./locales/fr/transit.json"
import frValidation from "./locales/fr/validation.json"

export const resources = {
  fr: {
    common: frCommon,
    auth: frAuth,
    dashboard: frDashboard,
    nav: frNav,
    validation: frValidation,
    contracts: frContracts,
    cooperatives: frCooperatives,
    orders: frOrders,
    documents: frDocuments,
    intake: frIntake,
    milling: frMilling,
    lots: frLots,
    transit: frTransit,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    nav: enNav,
    validation: enValidation,
    contracts: enContracts,
    cooperatives: enCooperatives,
    orders: enOrders,
    documents: enDocuments,
    intake: enIntake,
    milling: enMilling,
    lots: enLots,
    transit: enTransit,
  },
} as const

i18n.use(initReactI18next).init({
  resources,
  lng: readLocale(),
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: "common",
  ns: [
    "common",
    "auth",
    "dashboard",
    "nav",
    "validation",
    "contracts",
    "cooperatives",
    "orders",
    "documents",
    "intake",
    "milling",
    "lots",
    "transit",
  ],
  interpolation: { escapeValue: false },
  returnNull: false,
})

z.config({
  customError: (issue) => {
    if (issue.code === "invalid_type" && issue.input === undefined) {
      return i18n.t("required", { ns: "validation" })
    }
    return undefined
  },
})

export function changeLocale(locale: Locale) {
  writeLocale(locale)
  void i18n.changeLanguage(locale)
}

export default i18n
